// extracted by mini-css-extract-plugin
export default {"CheckboxLabel":"CheckBox_CheckboxLabel__B1FDi","CheckboxBox":"CheckBox_CheckboxBox__jKY7z","CheckboxText":"CheckBox_CheckboxText__9cipb"};